import utils from '@/utils'
import axios from 'axios'
import Vue from 'vue'

const LIST_PARAMS_KEY = 'classroom:listParams'
const SCHEDULE_LIST_PARAMS_KEY = 'classroom:schedule:listParams'
const HOLIDAY_LIST_PARAMS_KEY = 'classroom:holiday:listParams'

export const classroom = {
  namespaced: true,
  state: {
    list: {
      data: [],
      meta: {},
    },
    listLoading: false,
    detail: {},
    detailLoading: false,
    deleteLoading: false,
    totalHours: [],
    totalHoursLoading: false,
    listParams: JSON.parse(localStorage.getItem(LIST_PARAMS_KEY)),
    studentList: {
      data: [],
      meta: {},
    },
    isStudentListLoading: false,
    generateSchedulesLoading: false,
    generatedSchedules: [],
    extendSchedulesLoading: false,
    extendedSchedules: [],
    scheduleList: {
      data: [],
      meta: {},
    },
    scheduleListLoading: false,
    scheduleListParams: JSON.parse(
      localStorage.getItem(SCHEDULE_LIST_PARAMS_KEY)
    ),
    searchList: {
      data: [],
      meta: {},
    },
    searchListLoading: false,
    holidayList: {
      data: [],
      meta: {},
    },
    holidayListLoading: false,
  },
  getters: {
    list: (state) => {
      return state.list
    },
    detail: (state) => {
      return state.detail
    },
    isListLoading: (state) => {
      return state.listLoading
    },
    isDetailLoading: (state) => {
      return state.detailLoading
    },
    isDeleteLoading: (state) => {
      return state.deleteLoading
    },
    totalHours: (state) => {
      return state.totalHours
    },
    isTotalHoursLoading: (state) => {
      return state.totalHoursLoading
    },
    listParams: (state) => {
      return state.listParams
    },
    isGenerateSchedulesLoading: (state) => {
      return state.generateSchedulesLoading
    },
    generatedSchedules: (state) => {
      return state.generatedSchedules
    },
    isExtendSchedulesLoading: (state) => {
      return state.extendSchedulesLoading
    },
    extendedSchedules: (state) => {
      return state.extendedSchedules
    },
    scheduleList: (state) => {
      return state.scheduleList
    },
    isScheduleListLoading: (state) => {
      return state.scheduleListLoading
    },
    scheduleListParams: (state) => {
      return state.scheduleListParams
    },
    searchList: (state) => {
      return state.searchList
    },
    isSearchListLoading: (state) => {
      return state.searchListLoading
    },
    holidayList: (state) => {
      return state.holidayList
    },
    isHolidayListLoading: (state) => {
      return state.holidayListLoading
    },
    studentList: (state) => {
      return state.studentList
    },
    isStudentListLoading: (state) => {
      return state.studetnListLoading
    },
    // unassignedStudents: (state) => {
    //   return state.unassignedStudents
    // },
    // isUnassignedStudentsLoading: (state) => {
    //   return state.unassignedStudentsLoading
    // }
  },
  mutations: {
    setList(state, data) {
      state.list = data
    },
    setDetail(state, data) {
      state.detail = data
    },
    setDetailProp(state, data) {
      for (const prop in data) {
        Vue.set(state.detail, prop, data[prop])
      }
    },
    setListLoading(state, data) {
      state.listLoading = data
    },
    setDetailLoading(state, data) {
      state.detailLoading = data
    },
    setDeleteLoading(state, data) {
      state.deleteLoading = data
    },
    setTotalHours(state, data) {
      state.totalHours = data
    },
    setTotalHoursLoading(state, data) {
      state.totalHoursLoading = data
    },
    setListParams(state, data) {
      localStorage.setItem(LIST_PARAMS_KEY, JSON.stringify(data))
    },
    setGenerateSchedulesLoading(state, data) {
      state.generateSchedulesLoading = data
    },
    setGeneratedSchedules(state, data) {
      state.generatedSchedules = data
    },
    setExtendSchedulesLoading(state, data) {
      state.extendSchedulesLoading = data
    },
    setExtendedSchedules(state, data) {
      state.extendedSchedules = data
    },
    setScheduleList(state, data) {
      state.scheduleList = data
    },
    setScheduleListLoading(state, data) {
      state.scheduleListLoading = data
    },
    setScheduleListParams(state, data) {
      localStorage.setItem(SCHEDULE_LIST_PARAMS_KEY, JSON.stringify(data))
    },
    setSearchList(state, data) {
      state.searchList = data
    },
    setSearchListLoading(state, data) {
      state.searchListLoading = data
    },
    setHolidayList(state, data) {
      state.holidayList = data
    },
    setHolidayListLoading(state, data) {
      state.holidayListLoading = data
    },
    setHolidayListParams(state, data) {
      localStorage.setItem(HOLIDAY_LIST_PARAMS_KEY, JSON.stringify(data))
    },
    setStudentList(state, data) {
      state.studentList = data
    },
    setStudentListLoading(state, isLoading) {
      state.studentListLoading = isLoading
    },
    // setUnassignedStudentsData(state, data) {
    //   state.unassignedStudents = data
    // },
    // setUnassignedStudentsLoading(state, isLoading) {
    //   state.unassignedStudentsLoading = isLoading
    // }
  },
  actions: {
    async getList({ commit, dispatch }, filters) {
      commit('setListLoading', true)
      try {
        const response = await axios.get(`/api/classrooms`, {
          params: filters,
          paramsSerializer: (params) => utils.toQueryString(params),
        })
        commit('setList', response.data)
      } catch (error) {
        dispatch(
          'handleError',
          { key: 'classroom/getList', error },
          { root: true }
        )
      } finally {
        commit('setListLoading', false)
      }
    },
    async search({ commit, dispatch }, { search, filters }) {
      commit('setSearchListLoading', true)
      try {
        const response = await axios.get(`/api/classrooms`, {
          params: {
            name: search,
            ...filters,
          },
          paramsSerializer: (params) => utils.toQueryString(params),
        })
        commit('setSearchList', response.data)
      } catch (error) {
        dispatch(
          'handleError',
          { key: 'classroom/search', error },
          { root: true }
        )
      } finally {
        commit('setSearchListLoading', false)
      }
    },
    async getDetail({ commit, dispatch }, id) {
      commit('setDetailLoading', true)
      try {
        const response = await axios.get(`/api/classrooms/${id}`)
        commit('setDetail', response.data.data)
      } catch (error) {
        dispatch(
          'handleError',
          { key: 'classroom/getDetail', error },
          { root: true }
        )
      } finally {
        commit('setDetailLoading', false)
      }
    },
    async create({ commit, dispatch }, data) {
      commit('setDetailLoading', true)
      try {
        const response = await axios.post('/api/classrooms', data)
        commit('setDetail', response.data.data)
      } catch (error) {
        dispatch(
          'handleError',
          { key: 'classroom/create', error },
          { root: true }
        )
      } finally {
        commit('setDetailLoading', false)
      }
    },
    async update({ commit, dispatch }, data) {
      commit('setDetailLoading', true)
      try {
        const response = await axios.put(`/api/classrooms/${data.id}`, data)
        commit('setDetail', response.data.data)
      } catch (error) {
        dispatch(
          'handleError',
          { key: 'classroom/update', error },
          { root: true }
        )
      } finally {
        commit('setDetailLoading', false)
      }
    },
    async delete({ commit, dispatch }, id) {
      commit('setDeleteLoading', true)
      try {
        await axios.delete(`/api/classrooms/${id}`)
      } catch (error) {
        dispatch(
          'handleError',
          { key: 'classroom/delete', error },
          { root: true }
        )
      } finally {
        commit('setDeleteLoading', false)
      }
    },
    async getStudentList({ commit, dispatch }, filters) {
      commit('setStudentListLoading', true)
      try {
        const response = await axios.get(`/api/classrooms/students`, {
          params: filters,
          paramsSerializer: (params) => utils.toQueryString(params),
        })
        commit('setStudentList', response.data)
      } catch (error) {
        dispatch(
          'handleError',
          { key: 'classroom/getStudentList', error },
          { root: true }
        )
      } finally {
        commit('setStudentListLoading', false)
      }
    },
    async getTotalHours({ commit, dispatch }, filters) {
      commit('setTotalHoursLoading', true)
      try {
        const response = await axios.get(`/api/classrooms/total-hours`, {
          params: filters,
          paramsSerializer: (params) => utils.toQueryString(params),
        })
        commit('setTotalHours', response.data)
      } catch (error) {
        dispatch(
          'handleError',
          { key: 'classroom/getTotalHours', error },
          { root: true }
        )
      } finally {
        commit('setTotalHoursLoading', false)
      }
    },
    async generateSchedules({ commit, dispatch }, data) {
      commit('setGenerateSchedulesLoading', true)
      let err = null
      try {
        const response = await axios.post(
          `/api/classrooms/${data.id}/generate-schedules`,
          data
        )
        commit('setGeneratedSchedules', response.data.data)
      } catch (error) {
        dispatch(
          'handleError',
          { key: 'classroom/generateSchedules', error },
          { root: true }
        )
        err = error
      } finally {
        commit('setGenerateSchedulesLoading', false)
      }
      return err
    },
    async extendSchedules({ commit, dispatch }, data) {
      commit('setExtendSchedulesLoading', true)
      let err = null
      try {
        const response = await axios.post(
          `/api/classrooms/${data.id}/extend-schedules`,
          data
        )
        commit('setExtendedSchedules', response.data.data)
      } catch (error) {
        dispatch(
          'handleError',
          { key: 'classroom/extendSchedules', error },
          { root: true }
        )
        err = error
      } finally {
        commit('setExtendSchedulesLoading', false)
      }
      return err
    },
    async getScheduleList({ commit, dispatch }, filters) {
      commit('setScheduleListLoading', true)
      try {
        const response = await axios.get(`/api/classroom-schedules`, {
          params: filters,
          paramsSerializer: (params) => utils.toQueryString(params),
        })
        commit('setScheduleList', response.data)
      } catch (error) {
        dispatch(
          'handleError',
          { key: 'classroom/getScheduleList', error },
          { root: true }
        )
      } finally {
        commit('setScheduleListLoading', false)
      }
    },
    async getHolidayList({ commit, dispatch }, filters) {
      commit('setHolidayListLoading', true)
      try {
        const response = await axios.get(`/api/holidays`, {
          params: filters,
          paramsSerializer: (params) => utils.toQueryString(params),
        })
        commit('setHolidayList', response.data)
      } catch (error) {
        dispatch(
          'handleError',
          { key: 'classroom/getHolidayList', error },
          { root: true }
        )
      } finally {
        commit('setHolidayListLoading', false)
      }
    },
  },
}
